/* eslint-disable import/first */

import Vue from 'vue'
import Router from 'vue-router'

import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import BootstrapVue from 'bootstrap-vue' // added
import 'bootstrap/dist/css/bootstrap.css' // added
import 'bootstrap-vue/dist/bootstrap-vue.css' // added

Vue.use(BootstrapVue) // added
Vue.component('v-select', vSelect)

Vue.use(Router)
import Index from '@/components/Index'
import Similarity from '@/components/Similarity'
import HelpPage from '@/components/help'
const router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/similarity',
      name: 'index',
      component: Index
    },
    {
      path: '/similarity/:id',
      name: 'similarity',
      component: Similarity
    },
    {
      path: '/help',
      name: 'help',
      component: HelpPage
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js